<template>
  <div class="settings-main">
    <the-side-menu />
    <router-view class="sub-view" />
  </div>
</template>

<script>
import TheSideMenu from './TheSideMenu/index'

export default {
  components: {
    TheSideMenu
  }
}
</script>

<style lang="scss" scoped>
.settings-main {
  display: flex;
}

@media screen and (max-width: 480px) {
  .settings-main {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.sub-view {
  max-width: calc(1080px - 180px - 48px);
}
</style>
